import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CMSListLayer from "../../components/CMS/CMSLayer";


const CMSList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="CMS" />

        {/* UsersListLayer */}
        <CMSListLayer />

      </MasterLayout>

    </>
  );
};

export default CMSList; 
